export interface PassageSelection {
  nodeId: string;
  revisionId: string;
  start: number;
  end: number;
  text: string;
}

const derived = "[data-reading-ignore], [data-reading-badge], .q-link-status, [data-annotation-indicators], [data-annotation-indicator], script, style, template";

/** Match canonical UTF-16 offsets, including hard breaks but excluding generated reader controls. */
export function passageText(node: Node): string {
  if (node instanceof Text) return node.data;
  if (node instanceof Element) {
    if (node.matches(derived)) return "";
    if (node.tagName === "BR") return "\n";
  }
  return [...node.childNodes].map(passageText).join("");
}

export function selectedPassage(root: Document, nodeId: string): PassageSelection | undefined {
  const reader = root.querySelector<HTMLElement>("[data-qprins-static-document]");
  const block = reader?.querySelector<HTMLElement>(`[data-comment-anchor='block'][data-node-id="${CSS.escape(nodeId)}"]`);
  const selection = root.getSelection();
  if (!block || !reader?.dataset.revisionId || !selection || selection.isCollapsed || selection.rangeCount !== 1) return;
  const range = selection.getRangeAt(0);
  const address = (node: Node) => (node instanceof Element ? node : node.parentElement)?.closest("[data-comment-anchor='block']");
  if (address(range.startContainer) !== block || address(range.endContainer) !== block) return;
  const prefix = range.cloneRange();
  prefix.selectNodeContents(block);
  prefix.setEnd(range.startContainer, range.startOffset);
  const start = passageText(prefix.cloneContents()).length;
  prefix.setEnd(range.endContainer, range.endOffset);
  const end = passageText(prefix.cloneContents()).length;
  const text = passageText(block).slice(start, end);
  if (!text.trim()) return;
  return { nodeId, revisionId: reader.dataset.revisionId, start, end, text };
}
